import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.object.define-properties";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.array.filter";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import _defineProperty from "/Users/jquense/src/react-overlays/www/node_modules/@babel/runtime/helpers/esm/defineProperty";
import "core-js/modules/es6.string.trim";
import _objectWithoutProperties from "/Users/jquense/src/react-overlays/www/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.array.map";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { Prism, useHighlight } from '@docpocalypse/prism-react-renderer';
import cn from 'classnames';
import React from 'react';

function addErrorHighlight(props, index, errorLocation) {
  if (errorLocation && index === errorLocation.line) {
    props.className = cn(props.className, 'token-line-error');
  }

  return props;
}

export var mapTokens = function mapTokens(_ref) {
  var tokens = _ref.tokens,
      getLineProps = _ref.getLineProps,
      getTokenProps = _ref.getTokenProps,
      lineNumbers = _ref.lineNumbers,
      errorLocation = _ref.errorLocation;
  return /*#__PURE__*/React.createElement(React.Fragment, null, tokens.map(function (line, i) {
    return (
      /*#__PURE__*/
      // eslint-disable-next-line react/no-array-index-key
      React.createElement("div", addErrorHighlight(getLineProps({
        line: line,
        key: String(i)
      }), i, errorLocation), lineNumbers && /*#__PURE__*/React.createElement("span", {
        className: "token-line-number"
      }, i + 1), line.map(function (token, ii) {
        return (
          /*#__PURE__*/
          // eslint-disable-next-line react/no-array-index-key
          React.createElement("span", Object.assign({
            key: ii
          }, getTokenProps({
            token: token,
            key: String(ii)
          })))
        );
      }))
    );
  }));
};

function CodeBlock(_ref2) {
  var code = _ref2.code,
      theme = _ref2.theme,
      language = _ref2.language,
      lineNumbers = _ref2.lineNumbers,
      props = _objectWithoutProperties(_ref2, ["code", "theme", "language", "lineNumbers"]);

  var highlight = useHighlight({
    code: code.trim(),
    Prism: Prism,
    theme: theme,
    language: language
  });
  return /*#__PURE__*/React.createElement("pre", {
    className: cn(props.className, highlight.props.className),
    style: _objectSpread({}, props.style, {}, highlight.props.style)
  }, /*#__PURE__*/React.createElement("code", null, mapTokens(_objectSpread({}, highlight, {
    lineNumbers: lineNumbers
  }))));
}

export default CodeBlock;